import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ServicioDTO } from "app/main/apps/shared/interfaces/servicio.interface";
import { CustomValidationService } from "app/main/apps/shared/services/util/customvalidation.service";
import { ValidadoresFormularioService } from "app/main/apps/shared/services/util/validadores-formulario.service";

@Component({
    selector: "app-dialog-precio-servicio",
    templateUrl: "./dialog-precio-servicio.component.html",
    styleUrls: ["./dialog-precio-servicio.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class DialogPrecioServicioComponent implements OnInit {
    formulario: FormGroup;
    constructor(
        public dialogRef: MatDialogRef<DialogPrecioServicioComponent>,
        private fb: FormBuilder,
        @Inject(MAT_DIALOG_DATA) public servicio: ServicioDTO,
        private customValidator: CustomValidationService,
        private validadoresSrvc: ValidadoresFormularioService
    ) {}

    ngOnInit(): void {
        this.initForm();
    }

    initForm() {
        this.formulario = this.fb.group(
            {
                desde: [
                    this.servicio.precioDesde,
                    {
                        validators: [
                            Validators.required,
                            Validators.pattern(
                                this.validadoresSrvc.regexSoloNumerosYPunto
                            ),
                        ],
                    },
                ],
                hasta: [
                    this.servicio.precioHasta,
                    {
                        validators: [
                            Validators.required,
                            Validators.pattern(
                                this.validadoresSrvc.regexSoloNumerosYPunto
                            ),
                        ],
                    },
                ],
            }
            // {
            //     validator: this.customValidator.verificaValorMenor(
            //         "desde",
            //         "hasta"
            //     ),
            // }
        );
    }

    get desde() {
        return this.formulario.get("desde");
    }

    get hasta() {
        return this.formulario.get("hasta");
    }
}
